export function numberValue(value: unknown, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

export function clampNumber(value: unknown, min: number, max: number, fallback: number) {
  return Math.max(min, Math.min(max, numberValue(value, fallback)));
}

export function minimumNumber(value: unknown, min: number, fallback: number) {
  return Math.max(min, numberValue(value, fallback));
}

export function estimateMinutesValue(value: unknown, fallback = 30) {
  return minimumNumber(value, 5, fallback);
}

export function progressValue(value: unknown, fallback = 0) {
  return clampNumber(value, 0, 100, fallback);
}

export function goalCurrentValue(value: unknown, fallback = 0) {
  return minimumNumber(value, 0, fallback);
}

export function nonNegativeNumberValue(value: unknown, fallback = 0) {
  return minimumNumber(value, 0, fallback);
}

export function positiveNumberValue(value: unknown, fallback = 1) {
  return minimumNumber(value, 1, fallback);
}

export function habitTargetPerWeekValue(value: unknown, fallback = 5) {
  return clampNumber(value, 1, 7, fallback);
}

export function requiredPositiveNumberValue(value: unknown) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export const ACCOUNT_TYPES = ["cash", "bank", "ewallet", "credit", "other"] as const;
export type AccountTypeValue = (typeof ACCOUNT_TYPES)[number];

export function accountTypeValue(value: unknown, fallback: AccountTypeValue = "cash"): AccountTypeValue {
  return (ACCOUNT_TYPES as readonly string[]).includes(value as string) ? (value as AccountTypeValue) : fallback;
}

export function progressModeValue(value: unknown, fallback: "auto" | "manual" = "auto"): "auto" | "manual" {
  return value === "auto" || value === "manual" ? value : fallback;
}

/** Returns 'auto'|'manual' only when explicitly set; undefined otherwise (absent = auto downstream). */
export function optionalProgressMode(value: unknown): "auto" | "manual" | undefined {
  return value === "auto" || value === "manual" ? value : undefined;
}
